import { Button, ButtonProps, styled } from "@mui/material";
import { ReactNode, Ref, forwardRef } from "react";
import { BodySizes } from "../../builder/useFontsLayout";
import { useCapitalization } from "../../builder/Theme";

export const SeeMoreButton = styled(
  forwardRef(
    (
      props: ButtonProps & {
        children?: ReactNode;
        target?: string;
      },
      ref: Ref<HTMLButtonElement>,
    ) => <Button variant="text" ref={ref} {...props} disableRipple />,
  ),
)(({ theme }) => {
  const { buttons } = theme.settings;
  const textTransform = useCapitalization(buttons?.capitalization);
  return {
    "&:hover, &:focus": {
      textDecoration: "underline",
      background: "none",
    },
    textTransform,
    fontSize:
      theme.typography[BodySizes[theme.settings.fonts.chips?.size || "medium"]]
        .fontSize,
  };
});
